/* Adds accordions to Infinite Options */
document.addEventListener('DOMContentLoaded', function() {
    function initializeAccordion(accordion) {
        // Find the label within the accordion
        const label = accordion.querySelector('label');
        const labelText = label ? label.textContent : 'Click to expand/collapse'; // Fallback if no label found
        
        // Create the accordion header
        const header = document.createElement('div');
        header.className = 'accordion-header';
        header.textContent = labelText;
        
        // Create a span element for the +/- sign
        const toggleSign = document.createElement('span');
        toggleSign.className = 'toggle-sign';
        toggleSign.textContent = ' +';
        
        // Append the toggle sign to the header
        header.appendChild(toggleSign);
        
        // Create the content wrapper
        const content = document.createElement('div');
        content.className = 'accordion-content';

        // Move all children of the accordion (excluding the label) into the content wrapper
        while (accordion.firstChild) {
            if (accordion.firstChild !== label) {
                content.appendChild(accordion.firstChild);
            } else {
                accordion.removeChild(label); // Hide and remove the label element
            }
        }

        // Append the header and content to the accordion
        accordion.appendChild(header);
        accordion.appendChild(content);

        // Initially hide the content
        content.style.display = 'none';

        // Add click event listener to the header
        header.addEventListener('click', function() {
            const isOpen = content.style.display === 'block';
            content.style.display = isOpen ? 'none' : 'block';
            toggleSign.textContent = isOpen ? ' +' : ' -'; // Update the sign
        });
    }

    // Initialize for already present elements
    document.querySelectorAll('.custom-accordion').forEach(initializeAccordion);

    // Setup a MutationObserver to watch for new elements
    const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            mutation.addedNodes.forEach(function(node) {
                if (node.classList && node.classList.contains('custom-accordion')) {
                    initializeAccordion(node);
                }
            });
        });
    });

    // Start observing the document body for changes
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
});



window.onload = function() {
  var mainNav = document.querySelector('.main-nav');
  if (mainNav) {
    var div = document.createElement('div');
    div.id = 'close-mobile-menu';
    div.textContent = '✕';
    mainNav.insertBefore(div, mainNav.firstChild);
  }
};

document.addEventListener('click', function(event) {
  if (event.target && event.target.id === 'close-mobile-menu') {
    var navToggle = document.querySelector('#sticky-header .nav-toggle');
    if (navToggle) {
      navToggle.click();
    }
  }
});

